export default __webpack_public_path__ + "static/media/icon-round-check.9b7dcda6.svg";